// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__XTiTU","large":"styles_large__1MCk5"};